/**
 * 获取目标用户信息
 * @author Kody
 * @see http://api.umucdn.cn/project/232/interface/api/4301
 */

import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';

export const getProfileBaseInfo = (toUmuId: string): Promise<IResponse<IProfileInfo>> => {
    const param = {
        to_umu_id: toUmuId,
    };

    return fetchData(Api.PROFILE_TARGET_USER_INFO, param);
};
